import { FC, useEffect } from 'react';
import { InputViewModel } from '@sitecore-jss/sitecore-jss-forms';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';
import classNames from 'classnames';

import { CustomFieldTypes } from 'components/customFieldTypes';

import { useFieldValues } from '../../contexts/FormValues/FieldValuesContext';
import { FieldModelWithConditions } from '../../types/formConditions';
import { checkConditions } from '../../utilities/conditionalRendering';

const TspFieldWrapper: FC<ValueFieldProps> = (props) => {
  const { fieldValues, setFieldHidden } = useFieldValues();

  const fieldModel = props.field.model as InputViewModel & FieldModelWithConditions;
  const { conditionSettings, itemId } = fieldModel;
  const { fieldKey, fieldConditions } = conditionSettings;

  const shouldHide = checkConditions(fieldKey, fieldConditions, fieldValues);

  useEffect(() => {
    if (itemId) {
      setFieldHidden(itemId, shouldHide);
    }
  }, [shouldHide, itemId, setFieldHidden]);

  if (shouldHide) {
    return (
      <div className="hidden" aria-hidden="true">
        <fieldset disabled>{props.children}</fieldset>
      </div>
    );
  }

  const { cssClass, fieldTypeItemId } = props.field.model;
  const formDesignerClasses = cssClass?.trim();
  const isHiddenField = [
    CustomFieldTypes.HiddenText,
    CustomFieldTypes.GoogleRecaptchaV3,
    CustomFieldTypes.HiddenReferrer,
  ]
    .map(String)
    .includes(fieldTypeItemId);

  const isEmailWithConfirmation = [CustomFieldTypes.EmailWithConfirmation]
    .map(String)
    .includes(fieldTypeItemId);

  if (isHiddenField || isEmailWithConfirmation) {
    return <>{props.children}</>;
  }

  const isCheckboxList = fieldTypeItemId === CustomFieldTypes.CheckboxList;
  const isButton = fieldTypeItemId === CustomFieldTypes.Button;

  return (
    <div
      className={classNames(
        'tsp-field-wrapper mb-6 px-3 -:basis-full',
        isButton && 'tsp-button-wrapper w-auto grow-0 basis-auto',
        !isCheckboxList && formDesignerClasses
      )}
    >
      {props.children}
    </div>
  );
};

export default TspFieldWrapper;
